import { render, staticRenderFns } from "./TrainConfig.vue?vue&type=template&id=43eb011b&"
import script from "./TrainConfig.vue?vue&type=script&lang=js&"
export * from "./TrainConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports